import { ILocation, Location } from './Location';

export interface IRetailer {
    id: number,
    name: string,
    logo: string,
    location: ILocation,
}

export class CreativeRetailer {
    public retailers: Retailer[] = [];
}

export class Retailer implements IRetailer {
    public id: number;

    public name: string;

    public logo: string;

    public location: ILocation;

    public constructor(id: number, name: string, logo: string, location: ILocation) {
        this.id = id;
        this.name = name;
        this.logo = logo;
        this.location = location;
    }

    public static Default(): IRetailer {
        return new Retailer(-1, '', '', Location.Default());
    }
}

export class LocalOffersRetailer {
    public id: number;

    public retailerId: number;

    public name: string;

    public address: string;

    public city: string;

    public state: string;

    public zip: string;

    public logoUrl: string;

    public distance: number;

    public sponsored: boolean;

    public latitude: number;

    public longitude: number;

    public get isAmazonFresh(): boolean {
        return this.retailerId === 4661;
    }

    public get isWholeFoods(): boolean {
        return this.retailerId === 2231;
    }

    public get isRalphs(): boolean {
        return this.retailerId === 1579;
    }

    constructor(id: number = -1, retailerId: number = -1, name: string = '', address: string = '', city: string = '', state: string = '',
        zip: string = '', logoUrl: string = '', distance: number = 10.0, sponsored: boolean = false, latitude: number = 0, longitude: number = 0) {
        this.id = id;
        this.retailerId = retailerId;
        this.name = name;
        this.address = address;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.logoUrl = logoUrl;
        this.distance = distance;
        this.sponsored = sponsored;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}
